import { z } from "zod"
import { LOCALE_KEYS } from "./constants"
import type { I18nObject, SupportedLocale } from "./types"

/**
 * Validation schema for i18n objects.
 * It's defined this way instead of using a record like z.record(LOCALE_KEYS, z.string()) because
 * enums can cause issues when passed to the schema definition of an LLM.
 */
export const i18nSchema = z.object(
	Object.fromEntries(
		LOCALE_KEYS.map((locale) => [locale, z.string().optional().nullable()]),
	),
) as z.ZodObject<
	Partial<{
		[locale in SupportedLocale]: z.ZodNullable<z.ZodOptional<z.ZodString>>
	}>,
	"strip",
	z.ZodTypeAny,
	I18nObject,
	I18nObject
>

/**
 * Strict validation schema for i18n objects.
 * It guarantees that all locales are defined in the object.
 */
export const strictI18nSchema = z.object(
	Object.fromEntries(LOCALE_KEYS.map((locale) => [locale, z.string()])),
) as z.ZodObject<
	Record<SupportedLocale, z.ZodString>,
	"strip",
	z.ZodTypeAny,
	Record<SupportedLocale, string>,
	Record<SupportedLocale, string>
>
